import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "panel"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 gy-2" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, " Summary ", -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card-text" }
const _hoisted_9 = /*#__PURE__*/_createVNode("abbr", { title: "{Timestamp}" }, "Generated", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("abbr", { title: "{ActivityUId}" }, "ActivityUId", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("abbr", { title: "{Message}" }, "Message", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("abbr", { title: "{StatusCode}" }, "StatusCode", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("abbr", { title: "{CompanyUId}" }, "Company", -1)
const _hoisted_18 = { class: "col-md-6 gy-2" }
const _hoisted_19 = { class: "card" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "Activity Details", -1)
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "card-text" }
const _hoisted_23 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.Name}" }, "Name", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.ActivityType}" }, "Type", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.Address}" }, "Address", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Find related")
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-6 gy-2" }
const _hoisted_32 = { class: "card" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, " Employee Details ", -1)
const _hoisted_34 = { class: "card-body" }
const _hoisted_35 = { class: "card-text" }
const _hoisted_36 = /*#__PURE__*/_createVNode("abbr", { title: "{Employee.FirstName} {Employee.LastName}" }, "Name", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("abbr", { title: "{Employee.Email}" }, "Email", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("abbr", { title: "{Employee.PhoneNumber}" }, "Phone", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("abbr", { title: "{Employee.ReferenceId}" }, "Account ID", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("abbr", { title: "{Employee.EmployeeUId}" }, "Uid", -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("abbr", { title: "{Employee.Departments}" }, "Departments", -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_48 = {
  key: 0,
  class: "card-text"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("strong", null, "Mismatched Data", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_51 = { key: 0 }
const _hoisted_52 = /*#__PURE__*/_createVNode("i", null, "none", -1)
const _hoisted_53 = { key: 0 }
const _hoisted_54 = /*#__PURE__*/_createVNode("i", null, "none", -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_56 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_57 = /*#__PURE__*/_createTextVNode("All events for this user")
const _hoisted_58 = { class: "col-md-6 gy-2" }
const _hoisted_59 = { class: "card" }
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, " Location details ", -1)
const _hoisted_61 = { class: "card-body" }
const _hoisted_62 = { class: "card-text" }
const _hoisted_63 = /*#__PURE__*/_createVNode("strong", null, "Event Location", -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("abbr", { title: "{Latitude}" }, "Latitude", -1)
const _hoisted_66 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_67 = /*#__PURE__*/_createVNode("abbr", { title: "{Longitude}" }, "Longitude", -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_69 = {
  key: 0,
  class: "card-text"
}
const _hoisted_70 = /*#__PURE__*/_createVNode("strong", null, "Start Location", -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.StartLocation.Address}" }, "Address", -1)
const _hoisted_73 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_74 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.StartLocation.Latitude}" }, "Latitude", -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_76 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.StartLocation.Longitude}" }, "Longitude", -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_78 = { key: 0 }
const _hoisted_79 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.StartLocation.Floor}" }, "Floor", -1)
const _hoisted_80 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_81 = { key: 1 }
const _hoisted_82 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.StartLocation.Business}" }, "Business", -1)
const _hoisted_83 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_84 = { key: 2 }
const _hoisted_85 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.StartLocation.Apartment}" }, "Apartment", -1)
const _hoisted_86 = {
  key: 1,
  class: "card-text"
}
const _hoisted_87 = /*#__PURE__*/_createVNode("strong", null, "Panic Location", -1)
const _hoisted_88 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_89 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.PanicLocation.Address}" }, "Address", -1)
const _hoisted_90 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_91 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.PanicLocation.Latitude}" }, "Latitude", -1)
const _hoisted_92 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_93 = /*#__PURE__*/_createVNode("abbr", { title: "{Activity.PanicLocation.Longitude}" }, "Longitude", -1)
const _hoisted_94 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_block = _resolveComponent("error-block")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", null, _toDisplayString(_ctx.msg), 1),
    _createVNode(_component_error_block, { errors: _ctx.errors }, null, 8, ["errors"]),
    (_ctx.event.Timestamp)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", {
            class: "btn btn-sm btn-outline-secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchAbbrTitle()))
          }, "Toggle template tags"),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("div", _hoisted_7, [
                  _createVNode("p", _hoisted_8, [
                    _hoisted_9,
                    _createTextVNode(": " + _toDisplayString(_ctx.getHumanDate(_ctx.event.Timestamp)), 1),
                    _hoisted_10,
                    _hoisted_11,
                    _createTextVNode(": " + _toDisplayString(_ctx.event.ActivityUId), 1),
                    _hoisted_12,
                    _hoisted_13,
                    _createTextVNode(": " + _toDisplayString(_ctx.event.Message), 1),
                    _hoisted_14,
                    _hoisted_15,
                    _createTextVNode(": " + _toDisplayString(_ctx.event.StatusCode), 1),
                    _hoisted_16,
                    _hoisted_17,
                    _createTextVNode(": " + _toDisplayString(_ctx.event.CompanyUId), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode("div", _hoisted_21, [
                  _createVNode("p", _hoisted_22, [
                    _hoisted_23,
                    _createTextVNode(": " + _toDisplayString(_ctx.event.Activity.Name), 1),
                    _hoisted_24,
                    _hoisted_25,
                    _createTextVNode(": " + _toDisplayString(_ctx.event.Activity.ActivityType), 1),
                    _hoisted_26,
                    _hoisted_27,
                    _createTextVNode(": " + _toDisplayString(_ctx.event.Activity.Address), 1),
                    _hoisted_28
                  ]),
                  _createVNode(_component_router_link, {
                    to: '/sheqsy/event?f.ActivityUId='+_ctx.event.ActivityUId,
                    class: "btn btn-primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_29
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode("div", _hoisted_31, [
              _createVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode("div", _hoisted_34, [
                  _createVNode("p", _hoisted_35, [
                    _hoisted_36,
                    _createTextVNode(": " + _toDisplayString(_ctx.event.Employee.FirstName) + " " + _toDisplayString(_ctx.event.Employee.LastName), 1),
                    _hoisted_37,
                    _hoisted_38,
                    _createTextVNode(": " + _toDisplayString(_ctx.event.Employee.Email), 1),
                    _hoisted_39,
                    _hoisted_40,
                    _createTextVNode(": " + _toDisplayString(_ctx.event.Employee.PhoneNumber), 1),
                    _hoisted_41,
                    _hoisted_42,
                    _createTextVNode(": " + _toDisplayString(_ctx.event.Employee.ReferenceId), 1),
                    _hoisted_43,
                    _hoisted_44,
                    _createTextVNode(": " + _toDisplayString(_ctx.event.Employee.EmployeeUId), 1),
                    _hoisted_45,
                    _hoisted_46,
                    _hoisted_47,
                    _createVNode("ul", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.event.Employee.Departments, (dept, index) => {
                        return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(dept), 1))
                      }), 128))
                    ])
                  ]),
                  (_ctx.event.MismatchData && _ctx.event.MismatchData.length > 0)
                    ? (_openBlock(), _createBlock("p", _hoisted_48, [
                        _hoisted_49,
                        _hoisted_50,
                        _createVNode("ul", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.event.MismatchData, (mismatch, index) => {
                            return (_openBlock(), _createBlock("li", { key: index }, [
                              _createTextVNode(_toDisplayString(mismatch.Field), 1),
                              _createVNode("ul", null, [
                                _createVNode("li", null, [
                                  _createTextVNode("Receiver: " + _toDisplayString(mismatch.OldValue), 1),
                                  (!mismatch.OldValue)
                                    ? (_openBlock(), _createBlock("span", _hoisted_51, [
                                        _hoisted_52
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("li", null, [
                                  _createTextVNode("Provider: " + _toDisplayString(mismatch.NewValue), 1),
                                  (!mismatch.NewValue)
                                    ? (_openBlock(), _createBlock("span", _hoisted_53, [
                                        _hoisted_54
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_router_link, {
                    to: '/sheqsy/employee/'+_ctx.event.Employee.EmployeeUId,
                    class: "btn btn-primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_55
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _hoisted_56,
                  _createVNode(_component_router_link, {
                    to: '/sheqsy/event?f.EmployeeUId='+_ctx.event.EmployeeUId,
                    class: "btn btn-primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_57
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_58, [
              _createVNode("div", _hoisted_59, [
                _hoisted_60,
                _createVNode("div", _hoisted_61, [
                  _createVNode("p", _hoisted_62, [
                    _createVNode("a", {
                      href: 'https://www.google.com/maps/search/?api=1&query=' + _ctx.event.Latitude + ',' + _ctx.event.Longitude,
                      target: "_blank"
                    }, [
                      _hoisted_63
                    ], 8, ["href"]),
                    _hoisted_64,
                    _hoisted_65,
                    _createTextVNode(": " + _toDisplayString(_ctx.event.Latitude), 1),
                    _hoisted_66,
                    _hoisted_67,
                    _createTextVNode(": " + _toDisplayString(_ctx.event.Longitude), 1),
                    _hoisted_68
                  ]),
                  (_ctx.event.Activity.StartLocation)
                    ? (_openBlock(), _createBlock("p", _hoisted_69, [
                        _createVNode("a", {
                          href: 'https://www.google.com/maps/search/?api=1&query=' + _ctx.event.Activity.StartLocation.Latitude + ',' + _ctx.event.Activity.StartLocation.Longitude,
                          target: "_blank"
                        }, [
                          _hoisted_70
                        ], 8, ["href"]),
                        _hoisted_71,
                        _hoisted_72,
                        _createTextVNode(": " + _toDisplayString(_ctx.event.Activity.StartLocation.Address), 1),
                        _hoisted_73,
                        _hoisted_74,
                        _createTextVNode(": " + _toDisplayString(_ctx.event.Activity.StartLocation.Latitude), 1),
                        _hoisted_75,
                        _hoisted_76,
                        _createTextVNode(": " + _toDisplayString(_ctx.event.Activity.StartLocation.Longitude), 1),
                        _hoisted_77,
                        (_ctx.event.Activity.StartLocation.Floor)
                          ? (_openBlock(), _createBlock("span", _hoisted_78, [
                              _hoisted_79,
                              _createTextVNode(": " + _toDisplayString(_ctx.event.Activity.StartLocation.Floor), 1),
                              _hoisted_80
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.event.Activity.StartLocation.Business)
                          ? (_openBlock(), _createBlock("span", _hoisted_81, [
                              _hoisted_82,
                              _createTextVNode(": " + _toDisplayString(_ctx.event.Activity.StartLocation.Business), 1),
                              _hoisted_83
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.event.Activity.StartLocation.Apartment)
                          ? (_openBlock(), _createBlock("span", _hoisted_84, [
                              _hoisted_85,
                              _createTextVNode(": " + _toDisplayString(_ctx.event.Activity.StartLocation.Apartment), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.event.Activity.PanicLocation)
                    ? (_openBlock(), _createBlock("p", _hoisted_86, [
                        _createVNode("a", {
                          href: 'https://www.google.com/maps/search/?api=1&query=' + _ctx.event.Activity.PanicLocation.Latitude + ',' + _ctx.event.Activity.PanicLocation.Longitude,
                          target: "_blank"
                        }, [
                          _hoisted_87
                        ], 8, ["href"]),
                        _hoisted_88,
                        _hoisted_89,
                        _createTextVNode(": " + _toDisplayString(_ctx.event.Activity.PanicLocation.Address), 1),
                        _hoisted_90,
                        _hoisted_91,
                        _createTextVNode(": " + _toDisplayString(_ctx.event.Activity.PanicLocation.Latitude), 1),
                        _hoisted_92,
                        _hoisted_93,
                        _createTextVNode(": " + _toDisplayString(_ctx.event.Activity.PanicLocation.Longitude), 1),
                        _hoisted_94
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}